import './GameCard.scss';

import React, { FunctionComponent } from 'react';
import { useQuery } from '@apollo/client';
import GamePlayHistoryDetailsPopover from './GamePlayHistoryDetailsPopover';
import NoCoverImage from '../../../assets/no-cover-vertical.svg';
import { resizeImageUrl } from '../../../shared/CdnImages';
import { GamePlayDataModel } from './GamePlayDataModel';
import { NCOM_PRODUCT_BY_ID, Product } from './useGamePlay';

const GameCard: FunctionComponent<GamePlayDataModel> = ({
    consumerId,
    applicationId,
    playTime,
}) => {
    const { data: gameDetails, loading } = useQuery<
        { products: Product[] },
        { input: { applicationIds: string[] } }
    >(NCOM_PRODUCT_BY_ID, {
        variables: {
            input: {
                applicationIds: [applicationId],
            },
        },
    });

    const storeProduct =
        gameDetails?.products?.find((product: Product) =>
            product?.productImage?.publicId?.includes('store/'),
        ) || gameDetails?.products[0];

    const title = storeProduct?.name || (loading ? '' : 'Unavailable');
    const titleClassname = !loading && !storeProduct?.name ? ' font-italic' : '';
    const imageUrl = storeProduct?.productImage?.url || '';

    return (
        <div className="game-card">
            <div className="game-card__image">
                <img src={imageUrl ? resizeImageUrl(imageUrl, 190) : NoCoverImage} alt={title} />
            </div>
            <div className="game-card__text">
                <div className={`game-card__title${titleClassname}`}>{title}</div>
                <div className="game-card__play-time">
                    <div>
                        <GamePlayHistoryDetailsPopover
                            applicationId={applicationId}
                            consumerId={consumerId}
                            buttonLabel="Total Play Time:"
                            daysAgo={14}
                        />
                    </div>
                    <div className={playTime ? '' : 'font-italic'}>{playTime || 'Unavailable'}</div>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
